import { normalizeLocale, type SupportedLocale } from '@/i18n/config';
import { AR } from '@/i18n/messaging-channels/ar';
import { DE } from '@/i18n/messaging-channels/de';
import { EN } from '@/i18n/messaging-channels/en';
import { ES } from '@/i18n/messaging-channels/es';
import { FR } from '@/i18n/messaging-channels/fr';
import { HI } from '@/i18n/messaging-channels/hi';
import { ID } from '@/i18n/messaging-channels/id';
import { IT } from '@/i18n/messaging-channels/it';
import { JA } from '@/i18n/messaging-channels/ja';
import { KO } from '@/i18n/messaging-channels/ko';
import { PT_BR } from '@/i18n/messaging-channels/pt-br';
import { RU } from '@/i18n/messaging-channels/ru';
import type { MessagingChannelsCopy } from '@/i18n/messaging-channels/types';
import { VI } from '@/i18n/messaging-channels/vi';
import { ZH } from '@/i18n/messaging-channels/zh';
import { ZH_TW } from '@/i18n/messaging-channels/zh-tw';

export type { MessagingChannelsCopy } from '@/i18n/messaging-channels/types';

export const MESSAGING_CHANNELS_COPY_BY_LOCALE: Record<
  SupportedLocale,
  MessagingChannelsCopy
> = {
  en: EN,
  ar: AR,
  es: ES,
  'pt-BR': PT_BR,
  fr: FR,
  it: IT,
  ko: KO,
  de: DE,
  ja: JA,
  hi: HI,
  ru: RU,
  zh: ZH,
  'zh-TW': ZH_TW,
  vi: VI,
  id: ID,
};

export function getMessagingChannelsCopy(
  locale: string | null | undefined
): MessagingChannelsCopy {
  return MESSAGING_CHANNELS_COPY_BY_LOCALE[normalizeLocale(locale)];
}

export type MessagingCopyValues = {
  channel?: string;
  account?: string;
  number?: string;
  time?: string;
  count?: string;
  date?: string;
  message?: string;
};

/** Fills `{channel}` style placeholders; values stay untranslated. */
export function formatMessagingCopy(
  template: string,
  values: MessagingCopyValues
): string {
  return template.replace(
    /\{(channel|account|number|time|count|date|message)\}/g,
    (token, key: keyof MessagingCopyValues) => values[key] ?? token
  );
}
